import axios from '../api/axios';

export async function getGenerations(options) {
  const res = await axios.get(`/vehicleGenerations`, options);

  return res.data;
}

export async function getGenerationsByModel(vehicleModelId) {
  const res = await axios.get(
    `/vehicleModels/${vehicleModelId}/vehicleGenerations`
  );

  return res.data;
}

export async function createGeneration(body) {
  console.log(body);
  const response = await axios.post(
    '/vehicleGenerations',
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function updateGeneration(generationId, body) {
  const response = await axios.patch(
    `/vehicleGenerations/${generationId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function deleteGeneration(generationId) {
  const response = await axios.delete(`/vehicleGenerations/${generationId}`);
  return response;
}
